import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
  size: {
    type: String,
    default: 'md',
    options: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
  },
  altText: {
    type: String,
    default: 'Profile Image',
  },
  pathImg: {
    type: String,
    default: '',
  },
  imgHover: {
    type: Boolean,
    default: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;
const profileSize = computed(() => {
  switch (props.size) {
    case '2xs':
      return 16;
    case 'xs':
      return 24;
    case 'sm':
      return 32;
    case 'md':
      return 48;
    case 'lg':
      return 56;
    case 'xl':
      return 64;
    case '2xl':
      return 128;
    default:
      return 48;
  }
});

const imgLoadError = ref<boolean>(false);

const handleImgError = () => {
  imgLoadError.value = true;
};

const __returned__ = { props, profileSize, imgLoadError, handleImgError, IconMaterial }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})